/**
 * Created by RKL on 26/08/2015.
 */
define('caccountAttachsItemView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'settings',
  'bootbox',
  'template!caccountAttachsItemTpl'
], function (
  module,
  Marionette,
  _,
  App,
  Settings,
  bootbox,
  viewTpl
) {
  'use strict';

  var CAccountsAttachmentsTabItemView =  Marionette.ItemView.extend({
    template: viewTpl,

    ui: {
      imageHolder: '.js-image-holder',
      imageHolderContainer: '.js-image-holder-container',
      edit: '.js-edit-icon',
      remove: '.js-remove-icon',
      modify: '.js-modify-icon',
      zoom: '.js-zoom-icon',
      download: '.js-download-icon'
    },

    events: {
      'click @ui.remove': 'onRemove',
      'click @ui.download': 'onDownload',
      'click @ui.zoom' : 'onZoom',
      'click @ui.modify' : 'onModify'
    },

    tagName: 'div',

    className: 'original-img-wrapper zoom-img editor-holder template-item',

    onRender: function() {
      var imageUrl = this.model.get('fileLink');

      this.ui.imageHolder.attr('src', imageUrl);
    },

    onRemove: function() {
      bootbox.confirm(_.i18n('common.confirmDelete'), _.bind(function (result) {
        if (result) {
          App.trigger('caccount:delete-attachment', this.model);
        }
      }, this));
    },

    onZoom: function() {
      App.trigger('caccount:attachments-zoom', this.model.get('id'));
    },

    onModify: function() {
      App.trigger('caccount:attachments-modify', this.model.get('secId'));
    }
  });

  module.exports = CAccountsAttachmentsTabItemView;
});
